import React, { MutableRefObject, PropsWithChildren } from 'react';
import { Box, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button/Button";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useMfwThemeProvider } from 'myfitworld-utils';
import globalMessages from 'src/messages';
import { useIntl } from 'react-intl';

export const CRUDListWrapper = ({ children }: { children: React.ReactNode }) =>
  <div style={{ display: 'flex' }}>
    {children}
  </div>;

export type CRUDListLeftContainerRef =
  MutableRefObject<HTMLDivElement | null>
  | ((instance: HTMLDivElement | null) => void)
  | null;


export const CRUDListLeftContainer = React.forwardRef(({ children }: PropsWithChildren<any>, ref: CRUDListLeftContainerRef) =>
  <div ref={ref} style={{ display: 'flex', flex: 1 }}>
    {children}
  </div>);

export const CRUDListRightContainer = (
  { children }:
    { children: React.ReactNode }
) =>
  <div style={{
    display: 'flex',
    flex: 1,
  }}>
    {children}
  </div>;

export const CRUDListHeader = (
  { title, ctaLabel, disabled, isViewMode, onClick, handleClose }:
    { title: string, ctaLabel: string, disabled: boolean, isViewMode: boolean, onClick: (event: React.MouseEvent) => void, handleClose: () => void }
) => {

  const {theme} = useMfwThemeProvider();
  const {formatMessage} = useIntl();

  const showBackButton = () => {
    if (title === 'Exercise' || title === 'Grocery' || isViewMode) {
      return false;
    } else {
      return true;
    }
  };
  return (

    <Box
      display="flex"
      alignItems="baseline"
      mb={2}
      ml={1}
      justifyContent='space-between'
    >
      {showBackButton() ? (<Button
        onClick={handleClose}
        aria-label="close"
        variant='text'
        component='h2'
        style = {{color: theme.theme.text.secondary}}
        startIcon={<ArrowBackIosIcon />}
      >
        {formatMessage(globalMessages.back)}
      </Button>) : (<Typography
        variant='h4'
        component='h1'
        color='textSecondary'
      >
        {title}
      </Typography>)}


      {!disabled &&
        <Box display='flex' justifyContent='flex-end'>
          <Button
            color='primary'
            onClick={onClick}
            disabled={disabled}
            style={{
              justifyContent: 'flex-end'
            }}
          >
            {ctaLabel}
          </Button>
        </Box>
      }
    </Box>)
};
